import { render } from "./MSidebarSeparator.vue?vue&type=template&id=f5e157ec&scoped=true"
import script from "./MSidebarSeparator.vue?vue&type=script&lang=js"
export * from "./MSidebarSeparator.vue?vue&type=script&lang=js"

import "./MSidebarSeparator.vue?vue&type=style&index=0&id=f5e157ec&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5e157ec"]])

export default __exports__